import { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import { AddMarketButton } from './AddMarketButton'
import { Market } from 'src/interfaces/market'
import { RemovableMarket } from './RemovableMarket'

interface Props {
  markets: Market[]
  className?: any
  onSelectMarket(tag: Market): void
  onSelectAllMarkets?(markets: Market[]): void
  onRemoveMarket(tag: Market): void
  allMarketsSelected: boolean
  disabled?: boolean
}

const AddMarketsComponent = ({
  markets,
  className,
  onSelectMarket,
  onRemoveMarket,
  onSelectAllMarkets,
  allMarketsSelected,
  disabled = false,
}: Props) => {
  return (
    <div css={[className]}>
      <div css={tw`w-full`}>
        <Typography css={tw`mb-1.5`} color={colors.SHADES_GREY_400} variant="h6">
          {allMarketsSelected || disabled ? 'Markets' : 'Add market(s)'}
        </Typography>
        <div css={tw`flex flex-wrap gap-2`}>
          {!disabled && !allMarketsSelected && (
            <AddMarketButton
              selectedMarkets={markets}
              onSelectMarket={onSelectMarket}
              onSelectAllMarkets={onSelectAllMarkets}
            />
          )}
          {markets.map((item) => (
            <RemovableMarket
              key={item.title}
              market={item}
              onRemove={disabled ? undefined : onRemoveMarket}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export const AddMarkets = memo(AddMarketsComponent)
